var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Inject, Injectable } from '@angular/core';
import { DiagramConsts } from '../../diagram/diagram-consts';
import { ImageUrlHelper } from '../../diagram/utils/imageUrlHelper';
import { SwitchHelper } from '../../diagram/utils/switch/switch-helper';
import { IndicatorLightHelper } from '../../diagram/utils/indicator-light/indicator-light-helper';
import { BarDirectionType } from '../../diagram/utils/bar-graph/bar-direction-type';
import { DatetimeSeparatorType } from '@flexem/fc-gui/model/datetime-display/datetime-separator-type';
import { TimeFormatType } from '@flexem/fc-gui/model/datetime-display/time-format-type';
import { DateFormatType } from '@flexem/fc-gui/model/datetime-display/date-format-type';
import { BarGraphConsts } from '../../element-setting/bar-graph/bar-graph-consts';
import { AppComponentBase } from '../../../../shared/app-component-base';
import { FontSizeHelper } from '../../shared/helpers/font-size-helper';
import { FontStyleHelper } from '../../shared/helpers/font-style-helper';
import { TextAlignHelper } from '../../shared/helpers/text-align-helper';
import { AppConsts } from '../../../../shared/AppConsts';
import * as go from '../../../../libs/gojs/release/go';
import { DEFAULT_GRAPH_SETTINGS } from '../../core/settings/graph/default-graph-settings';
import { DefaultGraphCategories } from '../../core/settings/graph/default-graph-categories';
import { LineStyleType } from '../../../view-data/shared/line/general/line-style-type';
import { CurveType } from '../../../view-data/components/history-curve/general/curve-type';
import { MeterConst } from '../../element-setting/meter/meter-const';
import { RingGraphConst } from '../../element-setting/ring-graph/ring-graph.const';
var PaletteService = /** @class */ (function (_super) {
    __extends(PaletteService, _super);
    function PaletteService(injector, templateService, defaultGraphSettings) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.templateService = templateService;
        _this.defaultGraphSettings = defaultGraphSettings;
        return _this;
    }
    /**
     * @param container : A reference to a DIV by its ID as a string.
     */
    PaletteService.prototype.createPalette = function (container, numericalDisplayText) {
        var defaultGraphSettings = this.defaultGraphSettings.settings;
        var switchGraphSettings = defaultGraphSettings.get(DefaultGraphCategories.Switch);
        var indicatorLightGraphSettings = defaultGraphSettings.get(DefaultGraphCategories.IndicatorLight);
        var numericalDisplayGraphSettings = defaultGraphSettings.get(DefaultGraphCategories.NumericalDisplay);
        var characterGraphSettings = defaultGraphSettings.get(DefaultGraphCategories.Character);
        var toggleViewGraphSettings = defaultGraphSettings.get(DefaultGraphCategories.ToggleView);
        var paletteNodeOption = [
            {
                category: DiagramConsts.elements.switchIndicatorLightKey,
                size: SwitchHelper.getDefaultSwitchSize(),
                useSwitch: true,
                switchSettings: SwitchHelper.getDefaultSwitchSettings(),
                useIndicatorLight: false,
                states: SwitchHelper.getDefaultSwitchStates(),
                useGraph: true,
                graphSetting: { id: switchGraphSettings.graphId, styles: [] },
                graphUrl: switchGraphSettings.url,
                locked: false
            },
            {
                category: DiagramConsts.elements.switchIndicatorLightKey,
                size: IndicatorLightHelper.getDefaultIndicatorLightSize(),
                useSwitch: false,
                useIndicatorLight: true,
                indicatorLightSettings: IndicatorLightHelper.getDefaultIndicatorLightSettings(),
                states: IndicatorLightHelper.getDefaultIndicatorLightStates(),
                useGraph: true,
                graphSetting: { id: indicatorLightGraphSettings.graphId, styles: [] },
                graphUrl: indicatorLightGraphSettings.url,
                locked: false
            },
            {
                category: DiagramConsts.elements.numericalDisplayKey,
                useGraph: true,
                graphSetting: { id: numericalDisplayGraphSettings.graphId, styles: [] },
                graphUrl: numericalDisplayGraphSettings.url,
                size: '228 32',
                fontSize: FontSizeHelper.defaultFontSize,
                font: FontStyleHelper.getDefaultFontStyle(),
                textAlign: TextAlignHelper.AlignCenter,
                stroke: FontStyleHelper.defaultFontColor,
                isUnderline: false,
                locked: false,
                showVariableText: true,
                showUnit: true,
                variableText: {
                    content: numericalDisplayText,
                    font: {
                        fontSize: FontSizeHelper.defaultFontSize,
                        isBold: false,
                        isItalic: false,
                        isUnderline: false,
                        color: FontStyleHelper.defaultFontColor,
                        textAlign: TextAlignHelper.AlignRight,
                        fontFamily: FontStyleHelper.defautFontFamily
                    }
                }
            },
            {
                category: DiagramConsts.elements.characterKey,
                label: {
                    content: '',
                    font: {
                        isUnderline: false,
                        fontSize: FontSizeHelper.defaultFontSize,
                        fontStyle: FontStyleHelper.getDefaultFontStyle(),
                        color: FontStyleHelper.defaultFontColor,
                        textAlign: TextAlignHelper.AlignCenter
                    }
                },
                size: '228 32',
                isSameVariable: true,
                useGraph: true,
                graphSetting: { id: characterGraphSettings.graphId, styles: [] },
                graphUrl: characterGraphSettings.url,
                locked: false,
                showVariableText: true,
                variableText: {
                    content: numericalDisplayText,
                    font: {
                        fontSize: FontSizeHelper.defaultFontSize,
                        isBold: false,
                        isItalic: false,
                        isUnderline: false,
                        color: FontStyleHelper.defaultFontColor,
                        textAlign: TextAlignHelper.AlignRight,
                        fontFamily: FontStyleHelper.defautFontFamily
                    }
                }
            },
            {
                category: DiagramConsts.elements.imageKey,
                imageId: ImageUrlHelper.defaultImageId,
                size: '120 90',
                locked: false
            },
            {
                category: DiagramConsts.elements.textKey,
                text: this.ls(AppConsts.localization.configureLocalizationSourceName, DiagramConsts.elements.textKey),
                fontSize: FontSizeHelper.defaultFontSize,
                font: FontStyleHelper.getDefaultFontStyle(),
                textAlign: TextAlignHelper.AlignCenter,
                stroke: FontStyleHelper.defaultFontColor,
                isUnderline: false,
                size: '60 40',
                locked: false
            },
            {
                category: DiagramConsts.elements.hyperlinkKey,
                text: this.ls(AppConsts.localization.configureLocalizationSourceName, DiagramConsts.elements.hyperlinkKey),
                fontSize: FontSizeHelper.defaultFontSize,
                font: FontStyleHelper.getDefaultFontStyle(),
                textAlign: TextAlignHelper.AlignCenter,
                stroke: FontStyleHelper.defaultFontColor,
                isUnderline: false,
                size: '60 40',
                locked: false,
                linkAddress: ''
            },
            {
                category: DiagramConsts.elements.barGraphKey,
                size: '50 200',
                min: 0,
                max: 100,
                showScale: false,
                useAlarmLimit: false,
                showPercentage: false,
                direction: BarDirectionType.DownToUp,
                borderColor: BarGraphConsts.defaultBorderColor,
                backgroundColor: BarGraphConsts.defaultBackgroundColor,
                barColor: BarGraphConsts.defaultBarColor,
                upperLimit: BarGraphConsts.defaultUpperLimit,
                lowerLimit: BarGraphConsts.defaultLowerLimit,
                upperLimitColor: BarGraphConsts.defaultUpperLimitColor,
                lowerLimitColor: BarGraphConsts.defaultLowerLimitColor,
                locked: false
            },
            {
                category: DiagramConsts.elements.meterKey,
                min: 0,
                max: 100,
                masterDivisionNumber: 10,
                subDivisionNumber: 5,
                showScale: true,
                size: '200 200',
                calibrationColor: MeterConst.defaultCalibrationColor,
                showCalibrationDigit: true,
                integerDigits: MeterConst.defaultIntegerDigits,
                fractionDigits: MeterConst.defaultFractionDigits,
                calibrationDigitFontStyle: MeterConst.defaultCalibrationDigitFontStyle,
                calibrationDigitColor: MeterConst.defaultCalibrationDigitColor,
                locked: false
            },
            {
                category: DiagramConsts.elements.toggleViewKey,
                size: '64 64',
                label: {
                    content: '',
                    font: {
                        isUnderline: false,
                        fontSize: FontSizeHelper.defaultFontSize,
                        fontStyle: FontStyleHelper.getDefaultFontStyle(),
                        color: FontStyleHelper.defaultFontColor
                    }
                },
                useGraph: true,
                graphSetting: { id: toggleViewGraphSettings.graphId, styles: [] },
                graphUrl: toggleViewGraphSettings.url,
                locked: false
            },
            {
                category: DiagramConsts.elements.straightLineKey,
                stroke: FontStyleHelper.defaultFontColor,
                strokeWidth: 1,
                geo: 'M 0 0 L 100 0',
                lineType: LineStyleType.Solid,
                isArrow: false,
                size: '300 1',
                locked: false
            },
            {
                category: DiagramConsts.elements.polyLineKey,
                stroke: FontStyleHelper.defaultFontColor,
                strokeWidth: 1,
                geo: 'M 0,80 L 20,0 40,80 60,0',
                lineType: LineStyleType.Solid,
                isArrow: false,
                size: '160 80',
                locked: false
            },
            {
                category: DiagramConsts.elements.polygonKey,
                fill: '#ffffff',
                geo: 'F M 0,17.32 L 10,0 30,0 40,17.32 30,34.64 10,34.64 z',
                size: '80 80',
                locked: false,
                stroke: FontStyleHelper.defaultFontColor,
                strokeWidth: 1,
                lineType: LineStyleType.Solid,
            },
            {
                category: DiagramConsts.elements.rectangleKey,
                stroke: FontStyleHelper.defaultFontColor,
                strokeWidth: 1,
                width: 120,
                height: 80,
                locked: false
            },
            {
                category: DiagramConsts.elements.ellipseKey,
                stroke: FontStyleHelper.defaultFontColor,
                strokeWidth: 1,
                size: '80 80',
                locked: false
            },
            {
                category: DiagramConsts.elements.sectorKey,
                stroke: FontStyleHelper.defaultFontColor,
                radius: 100,
                sweep: 45,
                angle: 315,
                strokeWidth: 1,
                locked: false
            },
            {
                category: DiagramConsts.elements.dateTimeKey,
                showTime: true,
                showDate: false,
                dateFormat: DateFormatType.YYMMDD,
                isTwelveHourHex: false,
                showFullYear: false,
                showWeek: false,
                showMonthDayWithoutZero: false,
                datetimeSeparator: DatetimeSeparatorType.Dot,
                timeFormat: TimeFormatType.HHMMSS,
                fontSize: FontSizeHelper.defaultFontSize,
                font: FontStyleHelper.getDefaultFontStyle(),
                textAlign: TextAlignHelper.AlignCenter,
                stroke: FontStyleHelper.defaultFontColor,
                size: '80 40',
                locked: false
            },
            {
                category: DiagramConsts.elements.historyCurveKey,
                size: '360 274',
                generalSetting: {
                    curveType: CurveType.Line,
                    refreshCycle: 30,
                    displayPeriod: 2
                },
                calibrationMarkSetting: {
                    showCalibration: true, calibrationColor: '#7f939f', showCalibrationDigit: true,
                    calibrationDigitFont: { fontSize: '12px', isBold: false, isItalic: false, isUnderline: false, color: '#000000' }
                },
                locked: false
            },
            {
                category: DiagramConsts.elements.ringGraphKey,
                size: '140 140',
                rotationDirection: RingGraphConst.defaultRotationDirection,
                isFullRing: RingGraphConst.defaultIsFullRing,
                startAngle: RingGraphConst.defaultStartAngle,
                endAngle: RingGraphConst.defaultEndAngle,
                radiusPercentage: RingGraphConst.defaultRadiusPercentage,
                minCalibration: RingGraphConst.defaultMinCalibration,
                maxCalibration: RingGraphConst.defaultMaxCalibration,
                showPercentage: false,
                showScale: false,
                borderColor: RingGraphConst.defaultBorderColor,
                backgroundColor: RingGraphConst.defaultBackgroundColor,
                barColor: RingGraphConst.defaultBarColor,
                upperLimit: RingGraphConst.defaultUpperLimit,
                lowerLimit: RingGraphConst.defaultLowerLimit,
                upperLimitColor: RingGraphConst.defaultUpperLimitColor,
                lowerLimitColor: RingGraphConst.defaultLowerLimitColor,
                useAlarmLimit: true,
                locked: false
            },
            {
                category: DiagramConsts.elements.pipeKey,
                isFlowBlock: true,
                isPipeWall: true,
                isFlow: false,
                geo: 'M 0,0 L 300,0',
                size: '300 0',
                locked: false
            },
            {
                category: DiagramConsts.elements.videoKey,
                size: '400 225',
                locked: false
            },
            {
                category: DiagramConsts.elements.tableKey,
                fill: '#ffffff',
                size: '242 122',
                locked: false,
                stroke: '#8ea0aa',
                splitLine: '#8ea0aa',
                strokeWidth: 1,
                lineType: LineStyleType.Solid,
                key: 'Alpha',
                left: true,
                isHiddenRowSplitLine: false,
                isHiddenColumnSplitLine: false,
                widths: [80, 80, 80],
                heights: [40, 40, 40],
                items: [
                    { columns: [{ column: 0, text: '' }, { column: 1, text: '' }, { column: 2, text: '' }] },
                    { columns: [{ column: 0, text: '' }, { column: 1, text: '' }, { column: 2, text: '' }] },
                    { columns: [{ column: 0, text: '' }, { column: 1, text: '' }, { column: 2, text: '' }] }
                ]
            },
            {
                category: DiagramConsts.elements.weatherKey,
                text: this.ls(AppConsts.localization.configureLocalizationSourceName, DiagramConsts.elements.weatherKey),
                fontSize: FontSizeHelper.defaultFontSize,
                font: FontStyleHelper.getDefaultFontStyle(),
                textAlign: TextAlignHelper.AlignCenter,
                fill: '#86A7C5',
                stroke: '#FFFFFF',
                size: '268 92',
                locked: false,
                resizeable: false
            },
        ];
        var palette = go.GraphObject.make(go.Palette, container, {
            // share the templates with the main Diagram
            nodeTemplateMap: this.templateService.getNodePaletteTemplateMap(),
            // groupTemplateMap: this.templateService.palGroupTemplateMap(),
            // nodeTemplate: template.nodeTemplate,  // shared with the main Diagram
            'contextMenuTool.isEnabled': false,
            allowZoom: false,
            maxSelectionCount: 1,
            layout: go.GraphObject.make(go.GridLayout, {
                alignment: go.GridLayout.Position,
                wrappingColumn: 3,
                spacing: new go.Size(5, 5)
            }),
            // initialize the Palette with a few furniture and structure nodes
            model: new go.GraphLinksModel(paletteNodeOption),
        });
        palette.layout.sorting = go.GridLayout.Forward;
        return palette;
    };
    PaletteService = __decorate([
        Injectable(),
        __param(2, Inject(DEFAULT_GRAPH_SETTINGS))
    ], PaletteService);
    return PaletteService;
}(AppComponentBase));
export { PaletteService };
